import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { SelectEl } from "common/components/select";
export function template() {
  return /* @__PURE__ */ jsx("div", { sel: ".mp-popover-card-container" }, /* @__PURE__ */ jsx("div", { sel: ".mp-card-header.mp-popover-card-header" }, /* @__PURE__ */ jsx(SvgIconEl, { sel: ".svg-title-icon", attrs: { icon: this.attr(`is-segmented`) ? `segment` : `event` } }), /* @__PURE__ */ jsx("div", { sel: ".mp-card-header-title" }, this.attr(`title`), /* @__PURE__ */ jsx("div", { sel: ".mp-card-header-subtitle" }, this.attr(`subtitle`))), /* @__PURE__ */ jsx(
    ButtonEl,
    {
      sel: ".mp-card-header-close",
      attrs: {
        theme: ButtonTheme.Tertiary,
        icon: `x`
      },
      on: { click: this.helpers.handleClose }
    }
  )), /* @__PURE__ */ jsx("div", { sel: ".body" }, /* @__PURE__ */ jsx("slot", null)), /* @__PURE__ */ jsx("div", { sel: ".footer" }, /* @__PURE__ */ jsx("slot", { attrs: { name: `footer` } }), this.helpers.getMainOptions().map((buttonOption) => /* @__PURE__ */ jsx("div", { sel: ".button-option-container" }, !buttonOption.values ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(
    ButtonEl,
    {
      attrs: {
        theme: ButtonTheme.Secondary,
        icon: buttonOption.icon,
        disabled: buttonOption.isDisabled,
        ...buttonOption.tooltip ? {
          tooltip: {
            "max-width": `250px`,
            text: buttonOption.tooltip
          }
        } : {}
      },
      on: {
        click: this.helpers.handleSelect(buttonOption),
        mouseover: this.helpers.handleFocusItem(buttonOption),
        mouseout: this.helpers.handleUnfocusItem,
        disabled: buttonOption.disabled
      }
    },
    /* @__PURE__ */ jsx("span", { sel: ".button-label" }, buttonOption.label)
  )) : buttonOption.values ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(
    SelectEl,
    {
      attrs: {
        sections: [{ items: buttonOption.values }],
        "selected-option": buttonOption.label,
        disabled: buttonOption.isDisabled,
        ...buttonOption.tooltip ? {
          tooltip: {
            "max-width": `250px`,
            text: buttonOption.tooltip
          }
        } : {}
      },
      on: {
        change: this.helpers.handleChange,
        focusItem: this.helpers.handleFocusItem(buttonOption),
        menuChange: this.helpers.handleUnfocusItem
      }
    }
  )) : null)), this.helpers.hasOverflow() ? /* @__PURE__ */ jsx("div", { sel: ".button-option-container" }, /* @__PURE__ */ jsx(
    SelectEl,
    {
      attrs: {
        sections: [{ items: this.helpers.getOverflowOptions() }],
        icon: { leftIcon: `hor-ellipsis` }
      },
      on: { change: this.helpers.handleChange }
    }
  )) : null));
}
